module.exports = __webpack_public_path__ + "img/about-3.671d978b.png";